
// 弹窗页面——主流程
const MainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `page/popup/index${i + 1}`,
  name: `page/popupIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/popup/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 弹窗页面——主流程，开始
    ...MainRoutes
  ]
}
